import React from 'react';
import { StepNumberStyled, StepSubtitleStyled, StepTitleStyled, TitleWrapperStyled } from './styles';
import { STEP_NUMBER_TEST_ID } from '../constants';

export interface CensusStepProps {
  stepNumber?: string;
  stepTitle: string;
  stepSubtitle?: React.ReactNode;
  stepIcon?: React.ReactNode;
}

const StepHeader: React.FC<CensusStepProps> = ({ stepNumber, stepTitle, stepSubtitle, stepIcon }) => {
  return (
    <>
      <TitleWrapperStyled>
        {(stepIcon || stepNumber) && (
          <div>
            {stepIcon && stepIcon}
            {stepNumber && <StepNumberStyled data-test-id={STEP_NUMBER_TEST_ID}>{stepNumber}</StepNumberStyled>}
          </div>
        )}
        <StepTitleStyled>{stepTitle}</StepTitleStyled>
      </TitleWrapperStyled>
      <StepSubtitleStyled>{stepSubtitle}</StepSubtitleStyled>
    </>
  );
};

export default StepHeader;
